import { FormikErrors } from "formik";
import { TFunction } from "i18next";
import { EventFormValues } from "../../types/event";
import { getEventAddressStepValidator } from "./EventAddressStep";
import { getEventBaseDataStepValidator } from "./EventBaseDataStep";
import { getEventDetailsStepValidator } from "./EventDetailsStep";
import { getEventParticipationStepValidator } from "./EventParticipationStep";
import { getEventCostsStepValidator } from "./EventPlannedCostStep";
import { getEventUsersStepValidator } from "./EventUsersStep";

export const validateEventForm = (t: TFunction) => {
	return (values: EventFormValues): FormikErrors<EventFormValues> => {
		return {
			...getEventBaseDataStepValidator(t)(values),
			...getEventAddressStepValidator(t)(values),
			...getEventUsersStepValidator(t)(values),
			...getEventParticipationStepValidator(t)(values),
			...getEventCostsStepValidator(t)(values),
			...getEventDetailsStepValidator(t)(values),
		};
	};
};
